import gql from 'graphql-tag';

export const mockExamSchools = gql`
  query MockExamSchools($searchLocation: String!) {
    mockExamSchools(searchLocation: $searchLocation) {
      locationId
      locationCode
      locationName
    }
  }
`;
